const NOT_TOP_CLASS = 'not-top';
const FIXED_CLASS = 'fixed';


const stickyHeader = ( header ) => {
	if ( !header ) return;

	let lastScrollTop = 0;
	
	if ( window.pageYOffset > 10 )
	{
		header.classList.add( NOT_TOP_CLASS );
	}

	window.addEventListener( 'scroll', () => {
		let currentScroll = window.pageYOffset;

		if ( header.classList.contains( 'open-burger' ) || header.classList.contains( 'open-search' ) ) return;

		if (currentScroll > lastScrollTop)
		{
			header.classList.add( NOT_TOP_CLASS );
			header.classList.remove( FIXED_CLASS );
		}
		else
		{
			header.classList.remove( NOT_TOP_CLASS );
			header.classList.add( FIXED_CLASS );
		}

		lastScrollTop = currentScroll <= 10 ? 10 : currentScroll;

		if ( window.pageYOffset < 10 )
		{
			header.classList.remove( FIXED_CLASS );
		}
	} );
};

export {
	stickyHeader,
}
